export function normalizeJoinCode(input: string): string {
  const raw = String(input || '');
  return raw
    .trim()
    .replace(/[\s-]+/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 7);
}

export function isValidJoinCode(code: string, len: number = 6): boolean {
  const c = normalizeJoinCode(code);
  const re = new RegExp(`^[A-Z0-9]{${len}}$`);
  return re.test(c);
}
